/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Carrier_Address_RequiredInputs */

const en_orders_carrier_address_required = /** @type {(inputs: Orders_Carrier_Address_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete address is required: street, city, state, and postal code.`)
};

const es_orders_carrier_address_required = /** @type {(inputs: Orders_Carrier_Address_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La direccion completa es obligatoria: calle, ciudad, estado y codigo postal.`)
};

/**
* | output |
* | --- |
* | "Complete address is required: street, city, state, and postal code." |
*
* @param {Orders_Carrier_Address_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_address_required = /** @type {((inputs?: Orders_Carrier_Address_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Address_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_address_required(inputs)
	return es_orders_carrier_address_required(inputs)
});